export enum AutomationRequestType {
	UpgradeGroup = 1001,
	UpdateGroupSettings = 1002,
	ProvisionTeam = 2000,
	ArchiveTeam = 2001,
	DeleteTeam = 2002,
	AddMembersToTeam = 2003,
	ProvisionQualityManagement = 3000,
}
